/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { NotificationDeliveryChannelResponseDto } from './NotificationDeliveryChannelResponseDto';
import type { NotificationsAuthAttemptResponseDto } from './NotificationsAuthAttemptResponseDto';
import type { NotificationsClientResponseDto } from './NotificationsClientResponseDto';
import type { NotificationsDeviceResponseDto } from './NotificationsDeviceResponseDto';
import type { NotificationsEventResponseDto } from './NotificationsEventResponseDto';
export type NotificationsResponseDto = {
  /**
   * Unique identifier of the notification.
   */
  id: number;
  /**
   * Event to which the notification is related.
   */
  event?: NotificationsEventResponseDto;
  /**
   * Client to which the event occurred.
   */
  client: NotificationsClientResponseDto;
  /**
   * Device related to the event.
   */
  device?: NotificationsDeviceResponseDto;
  /**
   * Authentication attempt if notification is about OTP code.
   */
  authAttempt?: NotificationsAuthAttemptResponseDto;
  /**
   * Type of the notification.
   */
  type?: NotificationsResponseDto.type;
  /**
   * Timestamp when the notification was created
   */
  createdAt: string;
  /**
   * List of delivery channels used to send the notification
   */
  deliveryChannels: Array<NotificationDeliveryChannelResponseDto>;
};
export namespace NotificationsResponseDto {
  /**
   * Type of the notification.
   */
  export enum type {
    EVENT = 'EVENT',
    OTP_CODE = 'OTP_CODE',
    EMERGENCY_CONTACT_DELETED = 'EMERGENCY_CONTACT_DELETED',
    EMERGENCY_CONTACT_ACCEPT = 'EMERGENCY_CONTACT_ACCEPT',
    EMERGENCY_CONTACT_REJECT = 'EMERGENCY_CONTACT_REJECT',
    EMERGENCY_CONTACT_REMOVE = 'EMERGENCY_CONTACT_REMOVE',
    EMERGENCY_CONTACT_NO_RESPONSE_DELETE = 'EMERGENCY_CONTACT_NO_RESPONSE_DELETE',
  }
}

